<template>
  <SmallSquare content="自动回复图文消息类型中的图文数目只能发送一条。" class='m-b-10' />
  <div class='s_flex_bian_c m-b-10'>
    <div>
      <a-button type="primary" @click="create">新增图文</a-button>
    </div>
    <div>
      <a-form ref='form' :model='search' layout='inline'>
        <a-form-item label="类型" name='type'>
          <a-select v-model:value="search.type" :style="{width:'140px'}" placeholder="全部" @change="change">
            <a-select-option :value="1">普通图文</a-select-option>
            <a-select-option :value="2">高级图文</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </div>
  <a-card>
    <a-spin :spinning="listLoading">
      <ul class='s_flex_ali s_flex_wrap m-b-10' v-if='msgList.length'>
        <li v-for="(v,k) in msgList" :key="k" class='p-8 s_bor_cd9 ' :class="v.list.length>1?'disabled':''">
          <input type="radio" name="media_id" :id="v.id" hidden v-model="media" :value="v" :disabled="v.list.length>1">
          <div class="mark">
            <CheckOutlined class='fz-30 s_cfff' />
          </div>
          <label :for="v.id">
            <div class="media_header p-t-10 p-b-10 m-b-5">{{v.create_time}}</div>
            <div class="media_main m-b-10" :style="{backgroundImage:'url('+info.picdomain+'/'+v.list[0].image+')'}">
              <img src="@/assets/images/bgmoren.jpg" alt="" v-if="!v.list[0].image">
            </div>
            <div class="media_foot">
              {{v.list[0].title}}
            </div>
          </label>
        </li>
      </ul>
      <a-empty v-else />
    </a-spin>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
  </a-card>
  <div class='s_flex_end m-t-15'>
    <a-button @click="cancel" class='m-r-10'>取消</a-button>
    <a-button type="primary" @click="success">选择</a-button>
  </div>
</template>
<script>
  import { CheckOutlined } from "@ant-design/icons-vue";
  import { getWxGraphic, getWxGraphicSenior ,wx_graphicCheck} from "@/api/public_wx";
  import { inject, onMounted, reactive, ref, toRefs } from "vue";
  import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";

  import store from "@/store";
  const defForm = {
    page: 1,
    limit: 4,
    keyword: "",
    type: 1,
  };
  export default {
    name: "graphic",
    components: { CheckOutlined },
    setup(props, { emit }) {
      const state = reactive({
        listLoading: false,
        type: 1,
        media: null,
        total: 0,
        msgList: [],
        info: store.state.user.info,
      });
      const search = ref({...defForm});
      const change = (e) => {
        search.value.page = 1;
        state.media = null;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        let res;
        if (values && values.type == 1) {
          res = await getWxGraphic(values).then((res) => res.data);
        } else {
          res = await getWxGraphicSenior(values).then((res) => res.data);
        }
        state.listLoading = false;
        if (iscode(res)) {
          state.msgList = res.data.data;
          state.total = res.data.total;
        }
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      const $router = inject("$router");
      // 新增图文
      const create = () => {
        search.value.type == 1
          ? $router.push(
            "/wxPublic/wxManagement/drewManagement/wx_imgText_add?type=add"
          )
          : $router.push(
            "/wxPublic/wxManagement/drewManagement/high_imgText_add?type=add"
          );
      };
      // 确认选择
      const success = async() => {
        let result = await wx_graphicCheck({media_id:state.media.media_id ? state.media.media_id:state.media.id }).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          emit("success", state.media);
        }else{
          message.error(result.msg);
        }
      };
      // 取消
      const cancel = () => {
        emit("cancel");
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        change,
        pageCurrentChange,
        create,
        success,
        cancel,
      };
    },
  };
</script>
<style lang="less" scoped>
  ul {
    li {
      height: 300px;
      overflow: hidden;
      width: 23%;
      margin: 10px 1%;
      position: relative;

      .media_header {
        border-bottom: 1px solid #eee;
      }

      .media_main {
        width: 100%;
        height: 190px;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .media_foot {
        font-weight: 600;
      }

      .mark {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: none;
        justify-content: center;
        align-items: center;
      }

      input:checked~.mark {
        display: flex;
      }
    }

    .disabled {
      opacity: 0.5;
    }
  }
</style>